import { apiClient } from './client';
import type { DeploymentRecord, DeploymentSummary } from '../types';

export const deploymentsApi = {
  async getCurrent(): Promise<DeploymentSummary> {
    const { data } = await apiClient.get<DeploymentSummary>('/deployments/current');
    return data;
  },
  async runPreflight(): Promise<DeploymentRecord> {
    const { data } = await apiClient.post<DeploymentRecord>('/deployments/preflight');
    return data;
  },
  async runDryRun(): Promise<DeploymentRecord> {
    const { data } = await apiClient.post<DeploymentRecord>('/deployments/dry-run');
    return data;
  },
  async start(): Promise<DeploymentRecord> {
    const { data } = await apiClient.post<DeploymentRecord>('/deployments/start');
    return data;
  },
  async forceAwaitingConfirmation(): Promise<DeploymentRecord> {
    const { data } = await apiClient.post<DeploymentRecord>('/deployments/force-awaiting-confirmation');
    return data;
  },
  async confirm(id: string, decision: 'confirm' | 'abort'): Promise<DeploymentRecord> {
    const { data } = await apiClient.post<DeploymentRecord>('/deployments/confirm', { id, decision });
    return data;
  },
  async cancel(id: string): Promise<DeploymentRecord> {
    const { data } = await apiClient.post<DeploymentRecord>('/deployments/cancel', { id });
    return data;
  },
};
